import { render, staticRenderFns } from "./EditChildren.vue?vue&type=template&id=987f9464&scoped=true&"
import script from "./EditChildren.vue?vue&type=script&lang=js&"
export * from "./EditChildren.vue?vue&type=script&lang=js&"
import style0 from "./EditChildren.vue?vue&type=style&index=0&id=987f9464&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987f9464",
  null
  
)

export default component.exports